import { render, staticRenderFns } from "./MainEvents.vue?vue&type=template&id=fad82ab8&scoped=true&"
import script from "./MainEvents.vue?vue&type=script&lang=js&"
export * from "./MainEvents.vue?vue&type=script&lang=js&"
import style0 from "./MainEvents.vue?vue&type=style&index=0&id=fad82ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad82ab8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainShowMoreBtn: require('/web/components/MainShowMoreBtn.vue').default})
